<template>
	<el-input
		:id="id == null ? prop : id"
		v-model="localModelValue"
		:autocomplete="autocomplete"
		:dir="dir"
		@input="(value) => emitEvent('input', value)"
		:type="generalMethods.valueExist(type) ? type : generalMethods.valueExist(rows) ? 'textarea' : 'text'"
		:rows="rows"
		:min="min"
		:label="ariaLabel"
		:disabled="disabled"
		:readonly="readonly"
		:placeholder="placeholder"
		:size="size"
		:inputmode="inputmode"
		:autofocus="autofocus"
	>
		<template v-if="showPrepend" #prepend>
			<slot name="prepend" />
		</template>
	</el-input>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import * as generalMethods from "@/core/mixins/general_methods";
import * as customValidation from "@/core/mixins/custom_validation";

export default defineComponent({
	name: "umt-element-plus-input-core",
	props: {
		id: { type: String, default: null },
		label: { type: String, default: null },
		prop: { type: String, default: null },
		modelValue: {},
		autocomplete: { type: String, default: null },
		dir: { type: String, default: null },
		rows: { type: Number, default: null },
		ariaLabel: { type: String, default: null },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		showPrepend: { type: Boolean, default: false },
		placeholder: { type: String, default: null },
		size: { type: String, default: "default" },
		inputmode: { type: String, default: "" },
		autofocus: { type: Boolean, default: false },
		type: { type: String, default: null },
		min: { type: Number, default: null },
	},
	setup(props, { emit }) {
		const localModelValue = computed({
			get() {
				return props.modelValue;
			},
			set(newValue) {
				emit("update:modelValue", newValue);
			},
		});

		const emitEvent = (event, value) => {
			emit(event, value);
		};

		return {
			generalMethods,
			customValidation,

			localModelValue,

			emitEvent,
		};
	},
});
</script>
